import { correctDateForm } from 'utils/string';

export const handleSubmit = (values: any, { props }: any) => {
  const dataToSend = {
    telephone: values.phoneNumber,
    password: values.password,
    changedEmail: values.email,
    bday: values.birthday,
  };
  props.updateProfileSettingsInfo(dataToSend);
};

export const mapPropsToValues = (props: any) => {
  const email = props.profileSettingsInfo.email || '';
  return {
    birthday: correctDateForm(props.profileSettingsInfo.bday),
    phoneNumber: props.profileSettingsInfo.phone,
    email,
    oldEmail: email,
    language: props.profileSettingsInfo.language,
    isNotifEnabled: props.profileSettingsInfo.isNotifEnabled,
    password: '',
  };
};
